// ✅ Shared master lists for Business Signup & Media Outlet forms
const masterLists = {
  counties: [
    "Fairfield",
    "Hartford",
    "Litchfield",
    "Middlesex",
    "New Haven",
    "New London",
    "Tolland",
    "Windham"
  ],

  industries: [
    "Automotive",
    "Business Services / Consulting",
    "Childcare / Elder Care / Social Services",
    "Construction",
    "Education",
    "Entertainment",
    "Energy / Utilities",
    "Ecommerce",
    "Financial Services (personal & business loans)",
    "Food & Beverage",
    "Government",
    "Healthcare",
    "Health & Wellness (fitness, nutrition, lifestyle)",
    "Home Improvement",
    "Hospitality / Tourism",
    "Insurance",
    "Legal Services",
    "Manufacturing",
    "Marketing / Advertising / Media",
    "Nonprofit",
    "Political / Advocacy",
    "Professional Services (accounting, HR, IT, etc.)",
    "Real Estate",
    "Restaurants",
    "Retail",
    "Supermarkets / Grocery",
    "Technology / Software / IT",
    "Telecommunications",
    "Transportation / Logistics"
  ],

  marketingChannels: [
    "Social Media",
    "TV",
    "Radio",
    "Print (newspaper, magazine, flyer)",
    "Online banners or search ads",
    "Direct mail",
    "Events / Sponsorships",
    "Billboards / Outdoor ads",
    "Other"
  ],

  kpis: [
    "Website visits",
    "Social media engagement",
    "Lead generation (signups, inquiries)",
    "Sales or conversions",
    "Event attendance",
    "Brand awareness (surveys, mentions)",
    "Customer retention",
    "Other"
  ],

  certifications: [
    "Small Business Enterprise (SBE)",
    "Minority-Owned Business Enterprise (MBE)",
    "Women-Owned Business Enterprise (WBE)",
    "Veteran-Owned Business",
    "LGBTQ-Owned Business",
    "Other"
  ],

  audienceSegments: [
    "Men",
    "Women",
    "All genders",
    "Single individuals",
    "Married couples",
    "Divorced or widowed",
    "Families with children",
    "Families without children",
    "Young professionals",
    "College students / recent graduates",
    "Parents with young children",
    "Seniors (55+)",
    "Empty nesters",
    "Remote workers / homebased professionals",
    "New or repeat business customers"
  ]
};

export default masterLists;
